import React, { useContext, useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import config from "../../config";
import { GlobalContext } from "../../global/GlobalProvider";
import BetDetailsPopup from "./BetDetailsPopup";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTranslation } from "react-i18next";

export default function SecureAuth() {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("casino");
  const [password, setPassword] = useState("");
  const [isPassVerify, setIsPassVerify] = useState(false);
  const [connectionCode, setConnectionCode] = useState("");
  const [isAuth, setIsAuth] = useState(
    sessionStorage.getItem("issecureauthenable") || "false"
  );
  const initialized = useRef(false);
  const token = sessionStorage.getItem("token");
  const { setAlertMsg, openSuccessPopup, openErrorPopup, setLoading } = useContext(GlobalContext);

  const callChangeAuth = (flag) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    setLoading(true);

    let raw = JSON.stringify({
      issecureauth: flag,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/auth/changesecureauthstatus`,
      requestOptions
    )
      .then(async (response) => {
        let paresData = await response.json();
        console.log(paresData, "responseresponseresponse");
        setLoading(false);
        if (response.ok) {
          sessionStorage.setItem("issecureauthenable", flag);
        } else {
          openErrorPopup();
          setAlertMsg(paresData.message);
        }
      })
      .catch((error) => {
        openErrorPopup();
        setAlertMsg(error.message);
        setLoading(false);
        console.log(error);
      });
  };

  const callConnectionAPI = (pass) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    setLoading(true);

    let raw = JSON.stringify({
      password: pass,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/auth/getconnectioncode`,
      requestOptions
    )
      .then(async (response) => {
        let paresData = await response.json();
        setLoading(false);
        if (response.ok) {
          setIsPassVerify(true);
          setConnectionCode(paresData.connectcode)
        } else {
          openErrorPopup();
          setAlertMsg(paresData.message);
        }
      })
      .catch((error) => {
        openErrorPopup();
        setAlertMsg(error.message);
        setLoading(false);
        console.log(error);
      });
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsAuth(isChecked ? "true" : "false");
    callChangeAuth(isChecked ? "true" : "false");
  };

  const handleGetConnectionId = () => {
    let isValid = true;
    if (!password.trim()) {
      openErrorPopup();
      setAlertMsg("Password cannot be empty!");
      isValid = false;
      return;
    } else {
      setAlertMsg(""); // Clear error if valid
    }
    if (isValid) {
      callConnectionAPI(password);
    }
    // setIsAuth("true");
    // callChangeAuth("true");
  };

  return (
    <div className="content-box">
      <div className="report-box security-auth">
        <div className="report-title mt10">
          <div className="report-name">{t('Security Auth Verification')}</div>
        </div>

        <div>
          <div class="text-center">
            <b>{t('Security Auth Verification Status')}:</b>{" "}
            <span
              className={`badge badge-${
                isAuth === "false" ? "danger" : "success"
              }`}
            >
              {isAuth === "true" ? t("Enable") : t("Disable")}
            </span>
          </div>
          <div class="mt10 text-center">
            {t('Please select below option to enable secure auth verification')}
          </div>

          <div className="casino-report-tabs">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <span
                  data-toggle="tab"
                  onClick={() => setActiveTab("casino")}
                  className={`nav-link ${
                    activeTab === "casino" ? "active" : ""
                  }`}
                >
                  {t('Enable Using Telegram')}
                </span>
              </li>
            </ul>
          </div>
          {activeTab === "casino" ? (
            <div class={`tab-pane telegram`}>
              {isPassVerify ? (
                <div className="authentication-content">
                  <div className="content">
                    <h3 class="toggle-auth d-flex mb-20">
                      {t('Enable two factor authentication')}
                      <div class="checkbox m-0 ">
                        <input
                          type="checkbox"
                          className="switch teleauth"
                          name="teleauth"
                          checked={isAuth === "true"}
                          onChange={handleCheckboxChange}
                        />
                      </div>
                    </h3>
                    {isAuth === "true" ? <>
                    <div class="step-title mb-20">
                      <p>
                        <strong>{t('Thank you for enabling Login Security.')}</strong>
                      </p>
                      <p>
                        {t('To complete the setup and start receiving OTPs via Telegram, please follow the steps below:')}
                      </p>
                    </div>
                    <div class="shadowbox mb-20">
                      <p class="list-item flex gap10">
                        <strong>1.</strong>
                        <span>
                          {t('Open the Telegram app and search for')}{" "}
                          <strong>OTPVerification</strong>{" "}
                          (@secure_otpverification_bot) {t('Or open this link')}{" "}
                          <a
                            href="https://t.me/secure_otpverification_bot"
                            target="_blank"
                            class="primary-txt"
                          >
                            t.me/secure_otpverification_bot
                          </a>
                        </span>
                      </p>
                      <p class="list-item flex gap10">
                        <strong>2.</strong>
                        <span>
                          {t('Tap the Start button to initiate the chat with the bot.')}
                        </span>
                      </p>
                      <p class="list-item flex gap10">
                        <strong>3.</strong>
                        <span>
                          {t('Type the following command')}:{" "}
                          <strong class="connect-code primary-txt">
                            /connect {connectionCode}
                          </strong>
                        </span>
                      </p>
                      <p class="list-item flex gap10">
                        <strong>4.</strong>
                        <span>
                          {t('Once you receive a confirmation message, your Telegram-based OTP security will be successfully activated.')}
                        </span>
                      </p>
                    </div>
                    <p>
                      <strong>
                        {t('If you face any issues during setup, feel free to contact support.')}
                      </strong>
                    </p>
                    </> :''}
                  </div>
                </div>
              ) : (
                <div class="text-center connection-form">
                  <b>{t("Please enter your login password to continue")}</b>
                  <div class="form-group mt-3 secure-password">
                    <input
                      type="password"
                      placeholder={t("Enter your login password")}
                      class="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      class="btn btn-primary ml-2 vt"
                      onClick={handleGetConnectionId}
                    >
                      {t('Get Connection ID')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
